import '../timeline/components/about_box';
import '../timeline/components/activity/index.scss';
import '../timeline/components/activity_comment/index.scss';
import '../timeline/components/activity_reply/index.scss';
import '../timeline/components/new_activity';
import '../timeline/components/notebooks_card_list';
import '../timeline/components/profile_box';
import '../timeline/components/resources_box';
import '../timeline/components/sidebar_box';
import '../timeline/components/timeline_filter';
import '../timeline/components/timeline_loader';
import './index.scss';
import 'components/empty_list_message';
import 'components/modals/crop_image_modal';
import Timeline from '../timeline/lib/timeline';
import validator from 'utils/validator';

(function () {
  'use strict';
  validator.init();
  new Timeline().start();
})();
